import {
  Drawer,
  Empty,
  Skeleton,
  Table,
  Typography,
  message,
  Modal,
  Button,
  Form,
  Input,
  Select,
  Radio,
} from "antd";
import {
  EyeOutlined,
  LoadingOutlined,
  ArrowRightOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { isEmpty, debounce } from "lodash";
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { getRotoCompanyPaginationListNew } from "services/redux/Roto/rotoCompany/action";
import CompanyTemplateDetails from "./CompanyTemplateDetails";
import axios from "axios";
// import { getContactPersonPagination } from "services/redux/contact/contact.action";
import {
  contactCompanyGetDetails,
  getContactPersonPagination,
} from "services/redux/contact/companypeople/action";

import { actionForAddCompanyOrContactPersonEmailAddById } from "services/redux/Reference/action";

import {
  actionForAddCircularPlanningCompanyFromList,
  actionForGetCircularPlanningCompanyDtos,
  actionForUpdateCircularPlanningCompany,
} from "services/redux/Reference/DynamicCircularTemplate/action";
import { getCompanyorPersonEmailAddess } from "services/redux/contact/contact.action";
import QuickAddPerson from "components/modals/quickAddPerson";
import { appBaseUrl } from "utils/config";

const { Option } = Select;
const { Text } = Typography;

// Communication mode mapping
const communicationModeMap = {
  1: "Email",
  2: "Facebook",
  3: "Whatsapp",
  4: "Twitter",
  5: "Other",
};

// Form layout configuration
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

// Email validation regex
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function RotoCompanyTemplateViewTable({
  filterData,
  selectedTemplate,
}) {
  const dispatch = useDispatch();
  const pageSize = 30;

  // Redux selectors
  const { rotoCompanyDetails } = useSelector(
    (state) => state.rotoCompanyReducer
  );
  const { getDynamicCircularPlanningCompanyDtosResp } = useSelector(
    (state) => state.dynamicCircular
  );
  const {
    contactPersonPaginationResponse,
    contactPersonPaginationLoading,
    quickPersonAddResponse,
  } = useSelector((state) => state.contactCompanyPerson);

  const { contactCompanyPersonMailResponse, contactCompanyPersonMailLoading } =
    useSelector((state) => state.contact);

  // State management
  const [currentPage, setCurrentpage] = useState(1);
  const [viewDetailsDrawer, setViewDetailsDrawer] = useState(false);
  const [loadingStates, setLoadingStates] = useState({
    viewLoading: { key: null, isLoading: false },
    transferLoading: { key: null, isLoading: false },
  });
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isAddCompanyModelOpen, setIsAddCompanyModelOpen] = useState(false);
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);

  const [isAddCompanyEmailModalOpen, setIsAddCompanyEmailModalOpen] =
    useState(false);
  const [valueRadioAddCompany, setValueRadioAddCompany] = useState("1");
  const [selectedCompanyName, setSelectedCompanyName] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedCompanyCountry, setSelectedCompanyCountry] = useState("");
  const [searchKeywordContactPerson, setSearchKeywordContactPerson] =
    useState("");
  const [isPersonModalVisible, setIsPersonModalVisible] = useState(false);
  const [data, setData] = useState([]);
  // const [
  //   contactCompanyPersonMailResponse,
  //   setContactCompanyPersonMailResponse,
  // ] = useState([]);
  const [selectedAttendees, setSelectedAttendees] = useState([]);
  const [hasSelectedAttentionTos, setHasSelectedAttentionTos] = useState(false);
  const [isAddNewPersonStatus, setisAddNewPersonStatus] = useState(false);
  const [isAddCompanyEmailModalLoading, setIsAddCompanyEmailModalLoading] =
    useState(false);
  const [formCompanyId, setFormCompanyId] = useState(null);
  const [loadingPersons, setLoadingPersons] = useState(false);
  const [emailOptions, setEmailOptions] = useState([]);

  const fetchEmailOptions = useCallback(async () => {
    setLoadingPersons(true);
    try {
      const response = await dispatch(
        getCompanyorPersonEmailAddess(null, selectedCompanyId)
      );
      setEmailOptions(response.data || []);
    } catch (error) {
      message.error("Failed to fetch email options");
    } finally {
      setLoadingPersons(false);
    }
  }, [dispatch, selectedCompanyId]);

  // Form instances
  const [addCompanyModelForm] = Form.useForm();
  const [formQuickAddPerson] = Form.useForm();
  const [formAddCompanyEmail] = Form.useForm();

  // Derived values
  const emailReferenceId = selectedTemplate?.id || "";

  // Helper functions
  const validateCompanyForView = (record) => {
    if (!record?.id) {
      message.error("Invalid company data");
      return false;
    }
    return true;
  };

  const handleAddCompanyModal = () => {
    addCompanyModelForm.resetFields();
    setIsAddCompanyModelOpen(false);
    setFormCompanyId(null);
    setSelectedCompanyId(null);
    setHasSelectedAttentionTos(false);
  };

  const onChangeAddCompany = (value) => {
    setValueRadioAddCompany(value);
    setIsTemplateModalOpen(true);
  };

  const handleSelectChange = (values, options) => {
    const selectedData = options.map((option) => ({
      AttentionTo: option.props.children,
      AttentionId: option.key,
    }));
    let selectedPersonIds =
      selectedData &&
      selectedData?.map((item) => ({
        contactPersonIds: item?.AttentionId,
      }));
    setSelectedAttendees(selectedData);
    setHasSelectedAttentionTos(!isEmpty(values));

    debouncedDispatch(selectedPersonIds, selectedCompanyId);
  };

  const debouncedDispatch = useCallback(
    debounce((selectedPersonIds, selectedCompanyId) => {
      dispatch(
        getCompanyorPersonEmailAddess(selectedPersonIds, selectedCompanyId)
      );
    }, 300),
    [dispatch]
  );

  const handleQuickAddPersonModal = useCallback(() => {
    setIsPersonModalVisible(false);
    formQuickAddPerson.resetFields();
  }, [formQuickAddPerson]);

  const handleAddCompanyEmailModalClose = () => {
    formAddCompanyEmail.resetFields();
    setIsAddCompanyEmailModalOpen(false);
  };

  const onFinishAddCompany = (values) => {
    const body = {
      companyId: selectedCompanyId,
      circularPlanningTemplateId: selectedTemplate?.id,
      ModeofCommunication: communicationModeMap[valueRadioAddCompany] || null,
      attentionTo: JSON.stringify(
        (values.attendees || []).map((person) => ({
          AttentionTo: person.name,
          AttentionId: person.id,
        }))
      ),
      isactive: true,
      emailTo: JSON.stringify(values.emailTo || []), // Must be a non-empty array
      priority: values.priority || "",
    };

    try {
      dispatch(actionForUpdateCircularPlanningCompany(body)).then(
        (response) => {
          if (
            response &&
            response.error &&
            response.error.message === "Circular Planning company not found"
          ) {
            Modal.error({
              title: "Company Not Found",
              content: `The selected company (ID: ${selectedCompanyId}) was not found in Circular Planning. Please check if the company exists and is properly registered.`,
            });
          }
        }
      );
    } catch (err) {
      console.log("error", err);
    } finally {
      setIsAddCompanyModelOpen(false);
      addCompanyModelForm.resetFields();
    }
  };

  const onFinishAddCompanyEmail = async (values) => {
    const body = {
      companyId: selectedCompanyId,
      email: values?.newEmail ?? "",
    };

    setIsAddCompanyEmailModalLoading(true);

    try {
      if (body?.companyId) {
        await dispatch(actionForAddCompanyOrContactPersonEmailAddById(body));
        handleAddCompanyEmailModalClose();
        if (selectedCompanyId) {
          dispatch(getCompanyorPersonEmailAddess(null, selectedCompanyId));
        }
      }
    } catch (err) {
      console.log("Error: ", err);
    } finally {
      setIsAddCompanyEmailModalLoading(false);
    }
  };

  const handleViewDetails = async (record) => {
    if (!validateCompanyForView(record)) return;

    setLoadingStates((prev) => ({
      ...prev,
      viewLoading: { key: record.id, isLoading: true },
    }));

    try {
      dispatch(contactCompanyGetDetails({ contactCompanyId: record.id.id }));
      setViewDetailsDrawer(true);
    } catch (error) {
      message.error("Failed to load company details");
    } finally {
      setLoadingStates((prev) => ({
        ...prev,
        viewLoading: { key: null, isLoading: false },
      }));
    }
  };

  const handleTransferCompany = async (record) => {
    try {
      if (!selectedTemplate) {
        message.error("Please select a template first");
        return;
      }

      if (!record?.id) {
        message.error("Invalid company data");
        return;
      }

      setSelectedCompany({
        id: record.id,
        name: record.name,
      });
      setSelectedCompanyName(record.name);
      setSelectedCompanyId(record.id);
      setSelectedCompanyCountry(record.country || "");

      setIsAddCompanyModelOpen(true);
      addCompanyModelForm.resetFields();
      addCompanyModelForm.setFieldsValue({
        modeOfCommunication: "Email",
        companyName: record.name,
        country: record.country || "",
      });
    } catch (error) {
      console.error("Error in handleTransferCompany:", error);
      message.error("Failed to process company transfer");
    }
  };

  useEffect(() => {
    if (contactPersonPaginationResponse) {
      const newData = (contactPersonPaginationResponse?.items || []).map(
        (x) => ({
          label: x.personFullName,
          value: x.contactPersonId,
        })
      );

      setData(newData);
    }
  }, [contactPersonPaginationResponse]);

  useEffect(() => {
    if (!isEmpty(quickPersonAddResponse)) {
      const newPersonData = {
        label:
          quickPersonAddResponse.firstName + quickPersonAddResponse.lastName,
        value: quickPersonAddResponse.id,
      };

      // Checking if newPersonData already exists in data
      const isAlreadyAdded = data.some(
        (item) => item.value === newPersonData.value
      );

      if (!isAlreadyAdded) setData((prevData) => [...prevData, newPersonData]);
    }
  }, [quickPersonAddResponse]);

  const handleAttentionToFocus = async () => {
    if (!selectedCompanyId) return;

    try {
      setLoadingPersons(true);
      const response = await dispatch(
        getContactPersonPagination({
          CompanyId: selectedCompanyId,
          MaxResultCount: 100,
          SkipCount: 0,
        })
      );

      if (response.error) {
        message.error("Failed to fetch contact persons");
        return;
      }

      if (!response?.result?.items || response.result.items.length === 0) {
        // setIsPersonModalVisible(true);
        formQuickAddPerson.setFieldsValue({
          firstName: "",
          lastName: "",
          email: "",
          mobile: "",
          companyName: selectedCompanyName,
        });

        setEmailOptions([]);
        return;
      }

      const formattedData = response.result.items.map((person) => ({
        value: person.id,
        label: `${person.firstName} ${person.lastName}`,
        email: person.email,
      }));

      if (response.result.items.some((person) => person.email)) {
        // setContactCompanyPersonMailResponse(response.result.items);
      }
    } catch (error) {
      console.error("Error in handleAttentionToFocus:", error);
      // setIsPersonModalVisible(true);
      formQuickAddPerson.setFieldsValue({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        companyName: selectedCompanyName,
      });
    }
  };

  const getMoreData = () => {
    getData(pageSize, currentPage * pageSize, true);
  };

  const getData = (MaxResultCount = pageSize, SkipCount, loadMore = true) => {
    dispatch(
      getRotoCompanyPaginationListNew(
        {
          ...filterData,
          skipCount: SkipCount,
          maxResultCount: MaxResultCount,
        },
        loadMore
      )
    );
  };

  // Table columns definition
  const columns = [
    {
      title: "S No",
      key: "sno",
      render: (text, object, index) => index + 1,
      width: "5%",
    },
    {
      ellipsis: true,
      title: "Company Name",
      dataIndex: "name",
      key: "name",
      width: "40%",
    },
    {
      title: "Country",
      ellipsis: true,
      dataIndex: "country",
      key: "country",
      width: "20%",
    },
    {
      ellipsis: true,
      title: "SOW",
      dataIndex: "sow",
      key: "sow",
      width: "25%",
    },
    {
      title: "Action",
      width: "10%",
      render: (record) => (
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <div
            onClick={() => handleViewDetails(record)}
            style={{ cursor: "pointer" }}
          >
            {loadingStates.viewLoading.key === record.id &&
            loadingStates.viewLoading.isLoading ? (
              <LoadingOutlined />
            ) : (
              <EyeOutlined />
            )}
          </div>
          <div
            onClick={() => handleTransferCompany(record)}
            style={{ cursor: "pointer" }}
          >
            <ArrowRightOutlined />
          </div>
        </div>
      ),
    },
  ];

  // Effects
  useEffect(() => {
    if (selectedCompanyId) {
      handleAttentionToFocus();
    }
  }, [selectedCompanyId]);

  useEffect(() => {
    getData();
  }, [filterData]);

  useEffect(() => {
    if (selectedTemplate?.id) {
      dispatch(actionForGetCircularPlanningCompanyDtos(selectedTemplate.id));
    }
  }, [selectedTemplate]);
  const handleQuickAddPersonSubmit = async (values) => {
    try {
      // Call the real API
      const response = await axios.post(
        appBaseUrl + "contactRequest/quickPersonAdd",
        {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          phone: values.phone, // Include other fields if required
          // Add any other fields the API expects
        }
      );

      const newPerson = response.data;

      const formattedPerson = {
        id: newPerson.id, // Use the actual backend ID
        value: newPerson.id,
        label: `${newPerson.firstName} ${newPerson.lastName}`.trim(),
        email: newPerson.email,
        firstName: newPerson.firstName,
        lastName: newPerson.lastName,
      };

      // Update dropdown options
      setData((prevData) => [...prevData, formattedPerson]);

      // Set in "Attention To" (use value, not label)
      const prevAttendees =
        addCompanyModelForm.getFieldValue("attendees") || [];
      addCompanyModelForm.setFieldsValue({
        attendees: [...prevAttendees, formattedPerson.id],
      });

      // Update Email To options
      // setContactCompanyPersonMailResponse((prevEmails) => [
      //   ...prevEmails,
      //   { name: formattedPerson.label, email: formattedPerson.email },
      // ]);

      // If mode is Email, add to emailTo if not already present
      if (valueRadioAddCompany === "1") {
        const existingEmails =
          addCompanyModelForm.getFieldValue("emailTo") || [];
        if (
          formattedPerson.email &&
          !existingEmails.includes(formattedPerson.email)
        ) {
          addCompanyModelForm.setFieldsValue({
            emailTo: [...existingEmails, formattedPerson.email],
          });
        }
      }
      // Ensure country is always set after quick add, using latest value from selectedCompany, form, or state
      const currentCountry =
        (selectedCompany && selectedCompany.country) ||
        addCompanyModelForm.getFieldValue("country") ||
        selectedCompanyCountry ||
        "";
      addCompanyModelForm.setFieldsValue({
        country: currentCountry,
      });
      message.success("Person added successfully!");
      handleQuickAddPersonModal(); // Close modal
    } catch (error) {
      // console.error("❌ Error adding person:", error);
      message.error("Failed to add person");
    }
  };
  return (
    <>
      <div style={{ display: "flex" }}>
        <Typography.Title level={5}>
          <Text strong>Total Company - {rotoCompanyDetails?.totalCount}</Text>
        </Typography.Title>
      </div>

      {!isEmpty(rotoCompanyDetails?.items) ? (
        <>
          <div
            id="rotoCompanyDiv"
            style={{ height: "calc(100vh - 125px)", overflow: "auto" }}
          >
            <InfiniteScroll
              dataLength={rotoCompanyDetails?.items?.length}
              next={getMoreData}
              hasMore={
                rotoCompanyDetails?.totalCount >
                rotoCompanyDetails?.items?.length
              }
              loader={<Skeleton active paragraph={{ rows: 4 }} />}
              endMessage={
                <Text strong style={{ textAlign: "center" }}>
                  End of list
                </Text>
              }
              scrollThreshold={0.6}
              scrollableTarget="rotoCompanyDiv"
            >
              <Table
                size="small"
                columns={columns}
                dataSource={rotoCompanyDetails?.items}
                pagination={false}
                rowKey="id"
              />
            </InfiniteScroll>
          </div>
          {/* Modals and Drawers */}
          <Drawer
            title="Company Details"
            placement="right"
            onClose={() => setViewDetailsDrawer(false)}
            visible={viewDetailsDrawer}
            width={543}
          >
            <CompanyTemplateDetails />
          </Drawer>
          <Modal
            title="Add Company Temmplate"
            visible={isAddCompanyModelOpen}
            onCancel={handleAddCompanyModal}
            footer={null}
          >
            <Form
              {...formItemLayout}
              labelAlign="left"
              form={addCompanyModelForm}
              onFinish={onFinishAddCompany}
            >
              <Form.Item label="Country" name="country">
                <Input disabled />
              </Form.Item>
              <Form.Item label="Moc" name="modeOfCommunication">
                <Select
                  value={valueRadioAddCompany}
                  onChange={onChangeAddCompany}
                  defaultValue="1"
                >
                  <Option value="1">Email</Option>
                  <Option value="2">Facebook</Option>
                  <Option value="3">Whatsapp</Option>
                  <Option value="4">Twitter</Option>
                  <Option value="5">Other</Option>
                </Select>
              </Form.Item>
              <Form.Item label="Remarks" name="remarks">
                <Input.TextArea rows={4} placeholder="Remarks" />
              </Form.Item>
              <Form.Item label="Company Name">
                <div style={{ display: "flex" }}>
                  <Input disabled value={selectedCompanyName} />
                  <Button
                    type="dashed"
                    shape="circle"
                    onClick={() => setIsAddCompanyEmailModalOpen(true)}
                    icon={<PlusOutlined />}
                  />
                </div>
              </Form.Item>
              <Form.Item
                label="Priority"
                name="priority"
                rules={[
                  { required: true, message: "Please select a priority!" },
                ]}
              >
                <Select
                  placeholder="Select your priority"
                  options={[
                    { value: "1", label: "1" },
                    { value: "2", label: "2" },
                    { value: "3", label: "3" },
                  ]}
                />
              </Form.Item>
              <Form.Item label="Attention to" name="attendees">
                <Select
                  showSearch
                  mode="multiple"
                  autoComplete="off"
                  optionFilterProp="label"
                  placeholder="Select Person"
                  allowClear
                  onSearch={(value) => {
                    setSearchKeywordContactPerson(value);
                  }}
                  onChange={handleSelectChange}
                  notFoundContent={
                    <>
                      {contactPersonPaginationLoading ? (
                        <Skeleton />
                      ) : (
                        <div>
                          Content Not Found. Do you want to Person?
                          <Button
                            type="primary"
                            onClick={() => {
                              setIsPersonModalVisible(true);
                              // console.log("selectedCompanyId", body.companyId);
                              dispatch(
                                contactCompanyGetDetails(selectedCompanyId)
                              );
                              const namesArray =
                                searchKeywordContactPerson.split(" ");
                              formQuickAddPerson.setFieldsValue({
                                firstName: namesArray[0],
                                lastName: namesArray.slice(1).join(" ") || "",
                              });
                            }}
                          >
                            Yes
                          </Button>
                        </div>
                      )}
                    </>
                  }
                >
                  {data.map((option) => (
                    <Option
                      label={option.label}
                      key={option.value}
                      value={option.label}
                    >
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              {valueRadioAddCompany === "1" && (
                <Form.Item label="Email To" name="emailTo">
                  <Select
                    mode="multiple"
                    placeholder="Select Contact email"
                    style={{ width: "100%" }}
                    optionFilterProp="children"
                  >
                    {contactCompanyPersonMailResponse.map((contact) => (
                      <Option
                        key={`${contact.name}-${contact.email}`}
                        value={contact.email}
                      >
                        {contact.email} ({contact.name})
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
              <Form.Item wrapperCol={{ offset: 6, span: 18 }}>
                <Button
                  className="company-add-save-btn"
                  type="primary"
                  htmlType="submit"
                  style={{ marginRight: 8 }}
                  shape="round"
                >
                  Submit
                </Button>
                <Button
                  type="dotted"
                  onClick={() => {
                    setIsAddCompanyModelOpen(false);
                  }}
                  bordered={false}
                  shape="round"
                >
                  Close
                </Button>
              </Form.Item>
            </Form>
          </Modal>
          {/* QUICK ADD PERSOM*/}
          <Modal
            title="Quick Add Persson"
            visible={isPersonModalVisible}
            footer={null}
            onCancel={handleQuickAddPersonModal}
            style={{
              zIndex: 2000,
            }}
          >
            <QuickAddPerson
              form={formQuickAddPerson}
              previousForm={addCompanyModelForm}
              layout={formItemLayout}
              onCloseModal={handleQuickAddPersonModal}
              isAddNewPersonStatus={isAddNewPersonStatus}
              setisAddNewPersonStatus={setisAddNewPersonStatus}
              selectedCompanyName={selectedCompanyName}
              selectedCompanyId={selectedCompanyId}
            />
          </Modal>
          <Modal
            title="Add Company Email"
            visible={isAddCompanyEmailModalOpen}
            footer={null}
            onCancel={handleAddCompanyEmailModalClose}
          >
            {/* ADD EMAIL HERE */}
            <Form form={formAddCompanyEmail} onFinish={onFinishAddCompanyEmail}>
              <Form.Item
                label="Email Address"
                name="newEmail"
                rules={[
                  {
                    required: true,
                    message: "Please enter the company email!",
                  },
                  {
                    pattern: emailRegex,
                    message: "Please enter a valid email address!",
                  },
                ]}
              >
                <Input placeholder="Enter company email" />
              </Form.Item>
              <Form.Item>
                <Button
                  className="company-add-save-btn"
                  type="primary"
                  htmlType="submit"
                  shape="round"
                  loading={isAddCompanyEmailModalLoading}
                >
                  Add Email
                </Button>
              </Form.Item>
            </Form>
          </Modal>
          ;
        </>
      ) : (
        <Empty />
      )}
    </>
  );
}
